import { Radio } from 'lucide-react'
import { Tooltip } from '@/components/ui/tooltip'
import { useRealtime, type RealtimeStatus } from '@/lib/realtime'
import { cn } from '@/lib/utils/cn'

const META: Record<RealtimeStatus, { label: string; dot: string }> = {
  idle: { label: 'Tempo real desativado', dot: 'bg-slate-400' },
  connecting: { label: 'Conectando ao tempo real…', dot: 'bg-amber-500 animate-pulse' },
  connected: { label: 'Tempo real conectado', dot: 'bg-emerald-500' },
  disconnected: { label: 'Tempo real desconectado (reconectando)', dot: 'bg-amber-500' },
  error: { label: 'Falha no tempo real (reconectando)', dot: 'bg-red-500' },
  forbidden: {
    label: 'Sem permissão para tempo real (atualização periódica)',
    dot: 'bg-slate-400',
  },
}

export function RealtimeIndicator() {
  const { status } = useRealtime()
  const meta = META[status]
  return (
    <Tooltip label={meta.label}>
      <span
        tabIndex={0}
        aria-label={meta.label}
        data-status={status}
        data-testid="realtime-indicator"
        className="relative inline-flex h-9 w-9 items-center justify-center rounded-lg text-muted-foreground"
      >
        <Radio className="h-4 w-4" aria-hidden />
        <span
          className={cn(
            'absolute right-2 top-2 h-2 w-2 rounded-full ring-2 ring-background',
            meta.dot,
          )}
        />
      </span>
    </Tooltip>
  )
}
